import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { Stack, Typography, Box } from "@mui/material";

const previousMonthData = [
  { name: "Remaining", value: 70 },
  { name: "Growth", value: 30 },
];

const thisMonthData = [
  { name: "Remaining", value: 50 },
  { name: "Growth", value: 50 },
];

const COLORS = ["#0088FE", "#FF9A47"];
const tooltipFormatter = (value) => `${value}%`;

const AudienceGrowthComparison = () => {
  return (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
      >
        <Typography variant="p" gutterBottom>
          Audience Growth With Time
        </Typography>
        <Box display={"flex"} alignItems={"center"} gap={2}>
          <Box component={"div"} width={20} height={12} bgcolor={COLORS[1]} />
          <Typography variant="body2">Audience Growth</Typography>
        </Box>
      </Stack>
      <Stack direction="row" justifyContent="start" alignItems="center">
        <Box textAlign="center">
          <PieChart width={200} height={100}>
            <Pie
              data={previousMonthData}
              cx={100}
              cy={100}
              startAngle={180}
              endAngle={0}
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {previousMonthData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip formatter={tooltipFormatter} />
          </PieChart>
          <Typography variant="h6">Previous Month</Typography>

          {/* Legend */}
        </Box>

        <Box textAlign="center">
          <PieChart width={200} height={100}>
            <Pie
              data={thisMonthData}
              cx={100}
              cy={100}
              startAngle={180}
              endAngle={0}
              innerRadius={60}
              outerRadius={80}
              fill="#8884d8"
              paddingAngle={5}
              dataKey="value"
            >
              {thisMonthData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value}%`} />
          </PieChart>
          <Typography variant="h6">This Month</Typography>

          {/* Legend */}
        </Box>
      </Stack>
    </Box>
  );
};

export default AudienceGrowthComparison;
